import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import cz from "./locales/cz/translation.json";

export default i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "cz",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      cz: { translation: cz },
    },
    react: {
      useSuspense: false,
    },
  });
